export type CharStatus = "absent" | "present" | "correct";
export type CharStatuses = { [key: string]: CharStatus };

export const getStatuses = (solution: string, guesses: string[]): CharStatuses => {
  const charObj: { [key: string]: CharStatus } = {};
  const splitSolution = solution.split("");

  guesses.forEach((word) => {
    word.split("").forEach((letter, i) => {
      if (!splitSolution.includes(letter)) {
        return (charObj[letter] = "absent");
      }

      if (letter === splitSolution[i]) {
        return (charObj[letter] = "correct");
      }

      if (charObj[letter] !== "correct") {
        return (charObj[letter] = "present");
      }
    });
  });

  return charObj;
};

export const getRowStatus = (solution: string, guess: string): CharStatus[] => {
  const splitSolution = solution.split("");
  const splitGuess = guess.split("");

  return splitGuess.map((letter, i) => {
    if (!splitSolution.includes(letter)) {
      return "absent";
    }

    if (letter === splitSolution[i]) {
      return "correct";
    }

    return "present";
  });
};
